export {
  SYNTHETIC_DATA_DEMO_ARTIFACT_ID,
  SYNTHETIC_DATA_DEMO_ARTIFACT_SECTIONS,
  SYNTHETIC_DATA_DEMO_PDF_SHORT,
} from './syntheticDataDemoArtifact.part01.js'

import syntheticDataPdfUrl from '@/assets/Artifacts/An_overview_of_large_AI_models_and_their_applicati.pdf?url'
import { SYNTHETIC_DATA_DEMO_PDF } from './syntheticDataDemoContent.part01.js'

/** @returns {import('@/features/documentPreview/documentPreviewTypes.js').PdfPreviewPayload} */
export function buildSyntheticDataDemoArtifactPayload() {
  return {
    url: syntheticDataPdfUrl,
  }
}

/** @returns {import('@/features/documentPreview/documentPreviewTypes.js').GeneratedArtifactPreview} */
export function buildSyntheticDataDemoArtifactPreview() {
  return {
    artifactId: 'synthetic-data-large-ai-models-pdf',
    kind: 'pdf',
    fileName: SYNTHETIC_DATA_DEMO_PDF,
    description: 'PDF · 22 pages',
    payload: buildSyntheticDataDemoArtifactPayload(),
  }
}
